import { ColorPickerProps } from 'antd';
import { StyledColorPicker } from './ColorPickerStyles';

export type IColorPickerProps = ColorPickerProps;

const ColorPicker = (props: IColorPickerProps) => <StyledColorPicker {...props} />;

export default ColorPicker;
